import React, { FunctionComponent } from 'react';

import AdvertCard from '@Components/Advert/AdvertCard';
import { AdvertFragment } from '@Graphql/graphqlTypes.generated';

import styles from './AdvertList.module.scss';

type AdvertListProps = {
  adverts: AdvertFragment[];
};

const AdvertList: FunctionComponent<AdvertListProps> = ({ adverts }) => {
  return (
    <div className={styles.container}>
      {adverts.map(advert => (
        <AdvertCard key={advert.id} advert={advert} />
      ))}
    </div>
  );
};

export default AdvertList;
